import * as React from "react";
import {
  InputAdornment,
  TextField,
  StyleRulesCallback,
  withStyles,
  WithStyles,
  Typography
} from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import { BottomArrow } from "../Icons/BottomArrow/BottomArrow";
import Colors from "../../assets/Colors";
import { InputBaseComponentProps } from "@material-ui/core/InputBase";

export enum SLTextFieldType {
  Text,
  Dollar,
  Select
}

interface IProps {
  className?: string;
  slType?: SLTextFieldType;
  isDefaultSelection?: boolean;
  errorText?: string;
  label?: string;
  textFieldProps?: TextFieldProps;
  onChange?: (value: string) => void;
  inputComponent?: React.ReactType<InputBaseComponentProps>;
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flexShrink: 0
  },
  root: {
    height: 32,
    borderBottomColor: "#e4e8f0",
    borderBottomWidth: 2,
    borderBottomStyle: "solid"
  },
  inputRoot: {
    marginTop: "6px !important"
  },
  inputInputRoot: {
    fontSize: 16,
    color: palette.common.black,
    padding: 0,
    "&::placeholder": {
      color: palette.text.hint,
      opacity: 1
    }
  },
  label: {
    fontSize: 14,
    color: palette.common.black
  },
  labelError: {
    color: palette.error.main,
    marginLeft: 8
  },
  inputAdornment: {
    marginRight: 2
  },
  inputAdornmentText: {
    fontSize: 16,
    color: palette.text.hint,
    fontWeight: "bold"
  },
  bottomArrow: {
    width: 10,
    height: 4,
    marginTop: 6
  }
});

@(withStyles(styles) as any)
export default class SLTextField extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { classes, label, errorText, className } = this.props;
    return (
      <div className={[classes!.container, className].join(" ")}>
        <div className={classes!.label}>
          {label}
          <span className={classes!.labelError}>{errorText}</span>
        </div>
        {this.renderTextField()}
      </div>
    );
  }

  private renderTextField() {
    const {
      classes,
      slType,
      isDefaultSelection,
      textFieldProps,
      inputComponent
    } = this.props;
    const className = textFieldProps ? textFieldProps.className : "";
    return (
      <TextField
        className={`${classes!.root} ${className}`}
        InputLabelProps={{
          shrink: true,
          className: classes!.labelShrink
        }}
        inputProps={{
          className: classes!.inputInputRoot,
          style: {
            cursor: slType === SLTextFieldType.Select ? "pointer" : undefined,
            color: isDefaultSelection ? Colors.hint : undefined,
            width: "100%"
          }
        }}
        InputProps={{
          className: classes!.inputRoot,
          ...({ disableUnderline: true } as any), // TS issue
          startAdornment: this.inputStartAdornment(),
          endAdornment: this.inputEndAdornment(),
          inputComponent: inputComponent as any
        }}
        onChange={this.onChange}
        {...textFieldProps}
        value={(textFieldProps && textFieldProps.value) || ""}
      />
    );
  }

  private inputStartAdornment() {
    const { slType, classes } = this.props;
    switch (slType) {
      case SLTextFieldType.Dollar: {
        return (
          <InputAdornment className={classes!.inputAdornment} position="start">
            <Typography className={classes!.inputAdornmentText}>$</Typography>
          </InputAdornment>
        );
      }
      default:
        return null;
    }
  }

  private inputEndAdornment() {
    const { slType, classes } = this.props;
    switch (slType) {
      case SLTextFieldType.Select: {
        return (
          <InputAdornment position="end">
            <BottomArrow className={classes!.bottomArrow} />
          </InputAdornment>
        );
      }
      default:
        return null;
    }
  }

  private onChange = (event: any) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(event.target.value);
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/Input/SLTextField.tsx